import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Chip, List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { Email, Facebook, Instagram, Sms, Telegram, WhatsApp } from "@mui/icons-material";
import { format, parseISO } from "date-fns";
import api from "../../services/api";

// Histórico único do contato: os tickets dele em TODOS os canais (WhatsApp,
// e-mail, Messenger, Instagram...), não só o da conexão do ticket aberto.
// Backend: GET /contacts/:contactId/channel-history (canal de e-mail, 26/10/2026).

const ICONE = {
	email: <Email fontSize="small" sx={{ color: "#004f9f" }} />,
	facebook: <Facebook fontSize="small" sx={{ color: "#3b5998" }} />,
	instagram: <Instagram fontSize="small" sx={{ color: "#cd486b" }} />,
	telegram: <Telegram fontSize="small" sx={{ color: "#85b2ff" }} />,
	webchat: <Sms fontSize="small" sx={{ color: "#EB6D58" }} />
};

const STATUS = { open: "Atendendo", pending: "Aguardando", closed: "Fechado" };

const ContactChannelHistory = ({ contactId }) => {
	const [tickets, setTickets] = useState([]);
	const navigate = useNavigate();

	useEffect(() => {
		if (!contactId) return;
		let vivo = true;
		api
			.get(`/contacts/${contactId}/channel-history`)
			.then(({ data }) => vivo && setTickets(Array.isArray(data) ? data : []))
			.catch(() => vivo && setTickets([]));
		return () => {
			vivo = false;
		};
	}, [contactId]);

	if (!tickets.length) return null;
	const canais = new Set(tickets.map(t => t.whatsapp?.type || "wwebjs"));

	return (
		<Box sx={{ mt: 2 }} data-historico-canais>
			<Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
				Histórico em todos os canais {canais.size > 1 ? `(${canais.size} canais)` : ""}
			</Typography>
			<List dense disablePadding>
				{tickets.map(t => (
					<ListItemButton key={t.id} onClick={() => navigate(`/tickets/${t.id}`)} sx={{ borderRadius: 1 }}>
						<ListItemIcon sx={{ minWidth: 32 }}>
							{ICONE[t.whatsapp?.type] || <WhatsApp fontSize="small" sx={{ color: "#075e54" }} />}
						</ListItemIcon>
						<ListItemText
							primary={
								<Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
									<span>#{t.id} · {t.whatsapp?.name || "—"}</span>
									<Chip size="small" label={STATUS[t.status] || t.status} variant="outlined" />
								</Box>
							}
							secondary={`${t.updatedAt ? format(parseISO(t.updatedAt), "dd/MM/yy HH:mm") : ""} ${t.lastMessage || ""}`.slice(0, 110)}
						/>
					</ListItemButton>
				))}
			</List>
		</Box>
	);
};

export default ContactChannelHistory;
